export default __webpack_public_path__ + "static/media/Notebook.03f1a77e.webp";